import { Card, Group, Stack, Text, Title } from '@mantine/core';

import { useTranslation } from '@apple/lib/i18next';
import { FormattedDate } from '@apple/utils/globalization/components/FormattedDate';

import type { FiscalCalendarPeriod } from '@apple/features/calendar/models';

import type { BudgetSummaryItem } from '../models/budget';
import { BudgetDetails } from './BudgetDetails';

export interface BudgetItem extends BudgetSummaryItem {
	fiscalPeriod: FiscalCalendarPeriod | undefined;
}

export interface BudgetSummaryProps {
	fiscalYear: number;
	periodNumber: number;
	singleStoreCustomerCode: string;
	budgetItem?: BudgetItem;
	budgetItems?: BudgetItem[];
}

export function BudgetSummary({
	fiscalYear,
	periodNumber,
	singleStoreCustomerCode,
	budgetItem,
	budgetItems,
}: BudgetSummaryProps) {
	const { t } = useTranslation('common');

	return (
		<>
			{periodNumber && budgetItem ? (
				<>
					<Card pt='xs' my={0}>
						<Group grow justify='space-between'>
							<Group>
								<Text fw={700}>{`Budgeted: ${budgetItem?.budgetedAmount}`}</Text>
								<Text
									fw={700}
									c={budgetItem?.isOverBudget ? 'red' : 'green'}
								>{`Remaining: ${budgetItem?.difference}`}</Text>
							</Group>
							<Group justify='flex-end'>
								<Title order={3}> {budgetItem.fiscalPeriod?.periodName}</Title>
								<Group gap={1}>
									<FormattedDate value={budgetItem.fiscalPeriod?.startDate} />
									<Text mx={4}>-</Text>
									<FormattedDate value={budgetItem.fiscalPeriod?.endDate} />
								</Group>
							</Group>
						</Group>
					</Card>

					<BudgetDetails
						fiscalYear={fiscalYear}
						singleStoreCustomerCode={singleStoreCustomerCode}
						periodNumber={periodNumber}
						budgetItems={budgetItems}
					/>
				</>
			) : (
				<Stack>
					<Title order={3}>{t('pagination.empty')}</Title>
				</Stack>
			)}
		</>
	);
}
